import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  Row
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import Loader from "../../../../components/Common/Loader";
import {
  GET_BASIC_SETTING,
  UPDATE_BASIC_SETTING,
} from "../../../../services/ApiCalls";

const BasicSettings = ({ configData }) => {
  const { t } = useTranslation();
  const [dataSetting, setDataSetting] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("Thailand");
  const [enableAllNotifications, setEnableAllNotifications] = useState(true);
  const [emailDefault, setEmailDefault] = useState(true);
  const [inAppDefault, setInAppDefault] = useState(true);
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const res = await GET_BASIC_SETTING();
      if (res?.data?.status === "success") {
        const settings = res.data.data;
        setDataSetting(settings);
      }
    } catch (error) {
      toast.error(t("basicSettings.messages.failedToLoadSettings"));
    } finally {
      setLoading(false);
    }
  };


  const handlePaymentSettingChange = (country, index, field, value) => {
    setDataSetting((prev) => {
      const updatedSettings = { ...prev };
      const countryKey =
        country.toLowerCase() === "thailand"
          ? "thai_app_setting"
          : "viet_app_setting";

      if (!updatedSettings[countryKey]) {
        updatedSettings[countryKey] = {};
      }

      if (!updatedSettings[countryKey].paymentSetting) {
        updatedSettings[countryKey].paymentSetting = [];
      }

      const updatedPaymentSettings = [
        ...updatedSettings[countryKey].paymentSetting,
      ];
      updatedPaymentSettings[index] = {
        ...updatedPaymentSettings[index],
        [field]: value,
      };

      updatedSettings[countryKey].paymentSetting = updatedPaymentSettings;

      return updatedSettings;
    });
  };
  const handleRadiusChange = (value) => {
  setDataSetting((prev) => ({
    ...prev,
    radius: value,
  }));
};

  const handleSystemEmailChange = (country, field, value) => {
    setDataSetting((prev) => {
      const updatedSettings = { ...prev };
      const countryKey =
        country.toLowerCase() === "thailand"
          ? "thai_app_setting"
          : "viet_app_setting";

      if (!updatedSettings[countryKey]) {
        updatedSettings[countryKey] = {};
      }

      if (!updatedSettings[countryKey].systemEmails) {
        updatedSettings[countryKey].systemEmails = {};
      }

      updatedSettings[countryKey].systemEmails[field] = value;

      return updatedSettings;
    });
  };

  const handleBasicPaymentChange = (country, field, value) => {
    setDataSetting((prev) => {
      const updatedSettings = { ...prev };
      const countryKey =
        country.toLowerCase() === "thailand"
          ? "thai_app_setting"
          : "viet_app_setting";

      if (!updatedSettings[countryKey]) {
        updatedSettings[countryKey] = {};
      }
      updatedSettings[countryKey][field] = value;

      return updatedSettings;
    });
  };

  const globalChangeHandler = (field, value) => {
    setDataSetting((prev) => {
      const updatedSettings = { ...prev };
      updatedSettings.userNotification[field] = value;
      return updatedSettings;
    });
  }


const handleRewardSettingChange = (path, value) => {
  setDataSetting((prev) => {
    const updated = { ...prev };

    // Deep clone reward settings
    const reward = { ...updated.pointsEarningCreteria };

    if (path === "isEnabled") {
      reward.isEnabled = value;
    }

    if (path === "rewardPoints") {
      reward.rewardPoints = value;
    }

    if (path === "pendingDurationHours") {
      reward.lifecycle = {
        ...reward.lifecycle,
        pendingDurationHours: value,
      };
    }

    if (path === "expirationDays") {
      reward.lifecycle = {
        ...reward.lifecycle,
        expirationDays: value,
      };
    }

    if (path === "maxUsagePercentage") {
      reward.usageLimit = {
        ...reward.usageLimit,
        maxUsagePercentage: value,
      };
    }

    updated.pointsEarningCreteria = reward;

    return updated;
  });
};

const handleRewardRatioChange = (index, value) => {
  setDataSetting((prev) => {
    const updated = { ...prev };
    const reward = { ...updated.pointsEarningCreteria };

    const updatedValues = [...reward.value];
    updatedValues[index] = {
      ...updatedValues[index],
      pointToCurrencyRatio: value,
    };

    reward.value = updatedValues;
    updated.pointsEarningCreteria = reward;

    return updated;
  });
};



  const handleSave = async () => {
    setLoading(true);
    try {
      const res = await UPDATE_BASIC_SETTING(dataSetting);
      if (res?.data?.status === "success") {
        toast.success(t("basicSettings.messages.settingsUpdatedSuccessfully"));
      } else {
        toast.error(res?.data?.message || t("basicSettings.messages.failedToUpdateSettings"));
      }
    } catch (err) {
      toast.error(t("basicSettings.messages.somethingWentWrong"));
    } finally {
      setLoading(false);
    }
  };

  if (loading || !dataSetting) {
    return <Loader />;
  }

  const {
    thai_app_setting = {},
    viet_app_setting = {},
    languageSetting = [],
    cancellationReason = [],
    byPassEmailOtp,
    byPassMobileOtp,
    appName,
    disputeCategory,
    radius,
    distanceUnit,
     cancellationSettings,
  pointsEarningCreteria = {},
    exchangeRate = {},
    teamSuport = {},
    adminPanelUrl,
    hotelAdminPanelUrl
  } = dataSetting;

  const currentCountrySettings =
    selectedCountry === "Thailand" ? thai_app_setting : viet_app_setting;
  const paymentSettings = currentCountrySettings?.paymentSetting || [];

  return (
    <>
      <div className="p-4 bg-white rounded-4 shadow-sm">
        <h4 className="fw-bold mb-4">
          {t("basicSettings.title")}
        </h4>


        <Col lg="12" className="my-2">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h5 className="fw-bold text-dark mb-3">{t("basicSettings.globalSettings.title")}</h5>
              <Row className="align-items-center">
                <Col md="auto">
                  <Form.Check
                    type="switch"
                    id="enable-all-notifications"
                    label={t("basicSettings.globalSettings.enableAllNotifications")}
                    checked={dataSetting?.userNotification?.pushNotification || false}
                    onChange={(e) =>
                      globalChangeHandler("pushNotification", e.target.checked)
                    }
                    className="fw-medium"
                  />              
                </Col>
                <Col md="auto">
                  <Form.Check
                    type="switch"
                    id="email-default"
                    label={t("basicSettings.globalSettings.emailDefaultOn")}
                    checked={dataSetting?.userNotification?.email || false}
                    onChange={(e) => globalChangeHandler("email", e.target.checked)}
                    className="fw-medium"
                  />
                </Col>


              </Row>
            </Card.Body>
          </Card>
        </Col>

{/* <Col lg="12" className="my-2">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <h5 className="fw-bold text-dark mb-3">{t("basicSettings.globalSettings.sendGrid")}</h5>
              <Row className="align-items-center">
                <Col md="auto">
                 <p><b>apiKey</b> :  { dataSetting.sendGrid.apiKey}</p> 
                </Col>
                <Col md="auto">
                 <p><b>From</b> :{ dataSetting.sendGrid.from}</p>
                </Col>


              </Row>
            </Card.Body>
          </Card>
        </Col> */}

        <Col lg="12" className="my-2">
          <div className="shadow-sm p-4 rounded-4 d-flex flex-column gap-3">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="fw-semibold mb-0">
                {t("basicSettings.commissionPaymentSettings.title")}
              </h5>
              <Form.Select
                style={{ width: "200px" }}
                value={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
              >
                <option value="Vietnam">{t("basicSettings.countries.vietnam")}</option>
                <option value="Thailand">{t("basicSettings.countries.thailand")}</option>
              </Form.Select>
            </div>

            <Row>
              <Col md={12}>
                <Card className="p-3">
                  <h6 className="fw-semibold mb-3">
                    {t("basicSettings.commissionPaymentSettings.appSettings")} - {selectedCountry === "Thailand" ? t("basicSettings.countries.thailand") : t("basicSettings.countries.vietnam")}
                  </h6>


                  <Col className="d-flex" md={12}>
                    <Col md={6} className="mb-3">
                      <h6 className="fw-semibold">{t("basicSettings.commissionPaymentSettings.systemEmails")}</h6>
                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Form.Label column sm={8}>
                          {t("basicSettings.commissionPaymentSettings.promptPayEnabled")}
                        </Form.Label>
                        <Col sm={4}>
                          <Form.Check
                            type="switch"
                            checked={
                              currentCountrySettings.systemEmails
                                ?.promptPayEnabled || false
                            }
                            onChange={(e) =>
                              handleSystemEmailChange(
                                selectedCountry,
                                "promptPayEnabled",
                                e.target.checked
                              )
                            }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Form.Label column sm={8}>
                          {t("basicSettings.commissionPaymentSettings.vietnamEWalletEnabled")}
                        </Form.Label>
                        <Col sm={4}>
                          <Form.Check
                            type="switch"
                            checked={
                              currentCountrySettings.systemEmails
                                ?.vietnamEWalletEnabled || false
                            }
                            onChange={(e) =>
                              handleSystemEmailChange(
                                selectedCountry,
                                "vietnamEWalletEnabled",
                                e.target.checked
                              )
                            }
                          />
                        </Col>
                      </Form.Group>
                    </Col>

                    {/* Basic Payment Methods */}
                    <Col md={6} className="mb-3">
                      <h6 className="fw-semibold">{t("basicSettings.commissionPaymentSettings.paymentMethods")}</h6>
                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Form.Label column sm={8}>
                          {t("basicSettings.commissionPaymentSettings.cashEnabled")}
                        </Form.Label>
                        <Col sm={4}>
                          <Form.Check
                            type="switch"
                            checked={currentCountrySettings?.cashEnabled || false}
                            onChange={(e) =>
                              handleBasicPaymentChange(
                                selectedCountry,
                                "cashEnabled",
                                e.target.checked
                              )
                            }
                          />
                        </Col>
                      </Form.Group>
                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Form.Label column sm={8}>
                          {t("basicSettings.commissionPaymentSettings.creditCardEnabled")}
                        </Form.Label>
                        <Col sm={4}>
                          <Form.Check
                            type="switch"
                            checked={
                              currentCountrySettings?.creditCardEnabled || false
                            }
                            onChange={(e) =>
                              handleBasicPaymentChange(
                                selectedCountry,
                                "creditCardEnabled",
                                e.target.checked
                              )
                            }
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Col>
                </Card>
              </Col>




              {/* Payment Providers */}
              <Col md={12}>
                <Card className="p-3">
                  <h5 className="fw-semibold mb-3">
                    {t("basicSettings.commissionPaymentSettings.paymentProviders")} - {selectedCountry === "Thailand" ? t("basicSettings.countries.thailand") : t("basicSettings.countries.vietnam")}
                  </h5>

                  {paymentSettings.map((provider, index) => (
                    <div key={index} className="border rounded p-3 mb-3">
                      <h6 className="fw-semibold">
                        {provider.provider} {t("basicSettings.commissionPaymentSettings.providerSettings")}
                      </h6>

                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Form.Label column sm={4}>
                          {t("basicSettings.commissionPaymentSettings.enabled")}
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Check
                            type="switch"
                            checked={provider.isEnabled || false}
                            onChange={(e) =>
                              handlePaymentSettingChange(
                                selectedCountry,
                                index,
                                "isEnabled",
                                e.target.checked
                              )
                            }
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Form.Label column sm={4}>
                          {t("basicSettings.commissionPaymentSettings.mode")}
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Select
                            value={provider.mode || ""}
                            onChange={(e) =>
                              handlePaymentSettingChange(
                                selectedCountry,
                                index,
                                "mode",
                                e.target.value
                              )
                            }
                          >
                            <option value="Live">{t("basicSettings.modes.live")}</option>
                            <option value="Sandbox">{t("basicSettings.modes.sandbox")}</option>
                          </Form.Select>
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Form.Label column sm={4}>
                          {t("basicSettings.commissionPaymentSettings.apiKey")}
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            type="text"
                            value={provider.apiKey || ""}
                            onChange={(e) =>
                              handlePaymentSettingChange(
                                selectedCountry,
                                index,
                                "apiKey",
                                e.target.value
                              )
                            }
                            placeholder={t("basicSettings.commissionPaymentSettings.enterApiKey")}
                          />
                        </Col>
                      </Form.Group>

                      <Form.Group as={Row} className="align-items-center mb-2">
                        <Form.Label column sm={4}>
                          {t("basicSettings.commissionPaymentSettings.secretKey")}
                        </Form.Label>
                        <Col sm={8}>
                          <Form.Control
                            type="password"
                            value={provider.secretKey || ""}
                            onChange={(e) =>
                              handlePaymentSettingChange(
                                selectedCountry,
                                index,
                                "secretKey",
                                e.target.value
                              )
                            }
                            placeholder={t("basicSettings.commissionPaymentSettings.enterSecretKey")}
                          />
                        </Col>
                      </Form.Group>
                    </div>
                  ))}

                  {paymentSettings.length === 0 && (
                    <div className="text-center text-muted py-3">
                      {t("basicSettings.commissionPaymentSettings.noProvidersConfigured")} {selectedCountry === "Thailand" ? t("basicSettings.countries.thailand") : t("basicSettings.countries.vietnam")}
                    </div>
                  )}
                </Card>
              </Col>
            </Row>
          </div>
        </Col>

        <div className="shadow-sm p-4 rounded-4 d-flex flex-column gap-3">
          {/* Other Details */}

          <Col md={12}>
            <Card className="p-3">
              <h5 className="fw-semibold mb-3">
                {t("basicSettings.otherDetails.title")}
              </h5>
              <div className="mb-3">
                <div className="border rounded p-3 mb-3" >
                  <Form.Group as={Row} className="align-items-center mb-2">
                    <Form.Label column sm={4}>
                      {t("basicSettings.otherDetails.appName")}
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Control
                        type="text"
                        value={appName}
                        disabled={true}
                        placeholder={t("basicSettings.otherDetails.enterAppName")}
                      />
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="align-items-center mb-2">
                    <Form.Label column sm={4}>
                      {t("basicSettings.otherDetails.languageSetting")}
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Select
                        value={""}
                        disabled={true}
                      >
                        {languageSetting?.length && languageSetting?.map((ele) => {
                          return (
                            <option value={ele.name}>{ele?.name}</option>
                          )
                        })}

                      </Form.Select>

                    </Col>
                  </Form.Group>


 <Form.Group as={Row} className="align-items-center mb-2">
                    <Form.Label column sm={4}>
                      {t("basicSettings.otherDetails.adminurl")}
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Select
                        value={""}
                        disabled={true}
                      >
                        
                            <option value={adminPanelUrl}>{adminPanelUrl}</option>
                          
                        

                      </Form.Select>

                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="align-items-center mb-2">
                    <Form.Label column sm={4}>
                      {t("basicSettings.otherDetails.hoteladminurl")}
                    </Form.Label>
                    <Col sm={8}>
                      <Form.Select
                        value={""}
                        disabled={true}
                      >
                        
                            <option value={hotelAdminPanelUrl}>{hotelAdminPanelUrl}</option>
                          
                        

                      </Form.Select>

                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="align-items-center mb-2">
                    <Form.Label column sm={4}>
                      {t("basicSettings.otherDetails.cancellationReason")}
                    </Form.Label>
                    <Col sm={8}>

                      <Form.Select
                        disabled={true}
                        value={""}
                      >
                        {cancellationReason?.length && cancellationReason?.map((rsn) => {
                          return (
                            <option value={rsn}>{rsn}</option>
                          )
                        })}

                      </Form.Select>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} className="align-items-center mb-2">
                    <Form.Label column sm={4}>
                      {t("basicSettings.otherDetails.disputeCategory")}
                    </Form.Label>
                    <Col sm={8}>

                      <Form.Select
                        disabled={true}
                        value={""}
                      >
                        {disputeCategory?.length && disputeCategory?.map((rsn) => {
                          return (
                            <option value={rsn}>{rsn}</option>
                          )
                        })}

                      </Form.Select>
                    </Col>
                  </Form.Group>

                 <Form.Group as={Row} className="align-items-center mb-2">
  <Form.Label column sm={4}>
    {t("basicSettings.otherDetails.hotelSearchingRadius")}
  </Form.Label>
  <Col sm={8}>
    <Form.Control
      type="number"
      min={1}
      value={dataSetting?.radius ?? ""}
      onChange={(e) => handleRadiusChange(Number(e.target.value))}
      placeholder={t("basicSettings.otherDetails.hotelSearchingRadius")}
    />
  </Col>
</Form.Group>

                  <Form.Group as={Row} className="align-items-center mb-2">
                    <Form.Label column sm={4}>
                      {t("basicSettings.otherDetails.distanceUnit")}
                    </Form.Label>
                    <Col sm={8}>

                      <Form.Select
                        value={distanceUnit ?? ""}
                        disabled={true}
                      >

                        <option value={"mile"}>{t("basicSettings.distanceUnits.mile")}</option>
                        <option value={"km"}>{t("basicSettings.distanceUnits.km")}</option>


                      </Form.Select>
                    </Col>
                  </Form.Group>

                  <Col sm={12} className="d-flex justify-content-between gap-2"  >
                    <Form.Group column className="align-items-center mb-2">
                      <Form.Label column >
                        {t("basicSettings.otherDetails.bypassEmailOtp")}
                      </Form.Label>
                      <Col >
                        <Form.Check
                          disabled={true}
                          type="switch"
                          checked={
                            byPassEmailOtp || false
                          }
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group column className="align-items-center mb-2">
                      <Form.Label column >
                        {t("basicSettings.otherDetails.bypassMobileOtp")}
                      </Form.Label>
                      <Col >
                        <Form.Check
                          type="switch"
                          disabled={true}
                          checked={
                            byPassMobileOtp || false
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </div>

                <div className="border rounded p-3 mb-3" >

                  <h6 className="fw-semibold">{t("basicSettings.otherDetails.exchangeRate")}</h6>
                  <Col sm={12} className=" d-flex gap-2 justify-content-start" >
                    <Form.Group as={Row} className="align-items-center mb-2">
                      <Col  >
                        <Form.Label column >
                          {t("basicSettings.otherDetails.india")}
                        </Form.Label>
                        <Form.Control
                          disabled={true}
                          type="number"
                          value={exchangeRate?.INR}
                          placeholder={t("basicSettings.otherDetails.enter")}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="align-items-center mb-2">

                      <Col>
                        <Form.Label column >
                          {t("basicSettings.otherDetails.vietnam")}
                        </Form.Label>
                        <Form.Control
                          type="number"
                          disabled={true}
                          value={exchangeRate?.VND}
                          placeholder={t("basicSettings.otherDetails.enter")}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="align-items-center mb-2">

                      <Col >
                        <Form.Label column>
                          {t("basicSettings.otherDetails.thailand")}
                        </Form.Label>
                        <Form.Control
                          type="number"
                          disabled={true}
                          value={exchangeRate?.THB}
                          placeholder={t("basicSettings.otherDetails.enter")}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </div>

                <div className="border rounded p-3 mb-3 w-100" >
                  <h6 className="fw-semibold">{t("basicSettings.otherDetails.cancellationSettings")}</h6>

                  {
                    cancellationSettings?.rules?.length && cancellationSettings.rules?.map((ele) => {
                      return (
                        <Row className=" d-flex justify-content-start w-100" >
                          <Col sm={4}>
                            <Form.Group as={Row} className="align-items-center mb-2 w-100">
                              <Col>
                                <Form.Label column >
                                  {t("basicSettings.otherDetails.afterHours")}
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  disabled={true}
                                  value={ele?.afterHours}
                                  placeholder={t("basicSettings.otherDetails.enter")}
                                />
                              </Col>
                            </Form.Group>
                          </Col>

                          <Col sm={4}>
                            <Form.Group as={Row} className="align-items-center mb-2 w-100">

                              <Col   >
                                <Form.Label column >
                                  {t("basicSettings.otherDetails.refundType")}
                                </Form.Label>
                                <Form.Select
                                  value={ele?.refundType}
                                  disabled={true}
                                >
                                  <option value={"full"}>{t("basicSettings.otherDetails.full")}</option>
                                  <option value={"partial"}>{t("basicSettings.otherDetails.partial")}</option>
                                  <option value={"none"}>{t("basicSettings.otherDetails.none")}</option>
                                </Form.Select>
                              </Col>
                            </Form.Group>
                          </Col>
                          <Col sm={4}>

                            <Form.Group as={Row} className="align-items-center mb-2 W-100">
                              <Col   >
                                <Form.Label column >
                                  {t("basicSettings.otherDetails.refundValue")}
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  disabled={true}
                                  value={ele?.refundValue}
                                  placeholder={t("basicSettings.otherDetails.enter")}
                                />
                              </Col>

                            </Form.Group>
                          </Col>
                        </Row>
                      )
                    })
                  }

                </div>
                <div className="border rounded p-3 mb-3" >
                  <h6 className="fw-semibold">{t("basicSettings.otherDetails.teamSupport")}</h6>
                  <Col sm={12} className=" d-flex gap-2 justify-align-content-start" >
                    <Form.Group as={Row} className="align-items-center mb-2">
                      <Col  >
                        <Form.Label column >
                          {t("basicSettings.otherDetails.adminEmail")}
                        </Form.Label>
                        <Form.Control
                          type="email"
                          disabled={true}
                          value={teamSuport?.adminEmail}
                          placeholder={t("basicSettings.otherDetails.enter")}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="align-items-center mb-2">

                      <Col>
                        <Form.Label column >
                          {t("basicSettings.otherDetails.mobileNumber")}
                        </Form.Label>
                        <PhoneInput
                          country="in"
                          disabled={true}
                          value={teamSuport?.mobileNumber}
                          onChange={() => { }}
                          inputClass="form-control"
                          containerClass="w-100"
                        />
                      </Col>
                    </Form.Group>
                                        <Form.Group as={Row} className="align-items-center mb-2">

                      <Col>
                        <Form.Label column >
                          {t("basicSettings.otherDetails.lineId","Line Id")}
                        </Form.Label>
                      <Form.Control
                          type="email"
                          disabled={true}
                          value={teamSuport?.lineId}
                          placeholder={t("basicSettings.otherDetails.enter")}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </div>


              </div>


            </Card>
          </Col>
        </div>
        <div className="border rounded p-3 mb-3 w-100">
  <h6 className="fw-semibold">
    {t("basicSettings.otherDetails.rewardPointsSettings")}
  </h6>

  {/* Enable Rewards */}
  <Form.Group as={Row} className="align-items-center mb-3">
    <Form.Label column sm={4}>
      {t("basicSettings.otherDetails.enableRewards")}
    </Form.Label>
    <Col sm={8}>
      <Form.Check
        type="switch"
        checked={pointsEarningCreteria?.isEnabled || false}
        onChange={(e) =>
          handleRewardSettingChange("isEnabled", e.target.checked)
        }
      />
    </Col>
  </Form.Group>

  {/* Reward Points */}
  <Form.Group as={Row} className="align-items-center mb-2">
    <Form.Label column sm={4}>
      {t("basicSettings.otherDetails.rewardPoints")}
    </Form.Label>
    <Col sm={8}>
      <Form.Control
        type="number"
        value={pointsEarningCreteria?.rewardPoints || ""}
        onChange={(e) =>
          handleRewardSettingChange("rewardPoints", e.target.value)
        }
      />
    </Col>
  </Form.Group>

  {/* Lifecycle */}
  <Form.Group as={Row} className="align-items-center mb-2">
    <Form.Label column sm={4}>
      {t("basicSettings.otherDetails.pendingDurationHours")}
    </Form.Label>
    <Col sm={8}>
      <Form.Control
        type="number"
        value={
          pointsEarningCreteria?.lifecycle?.pendingDurationHours || ""
        }
        onChange={(e) =>
          handleRewardSettingChange(
            "pendingDurationHours",
            e.target.value
          )
        }
      />
    </Col>
  </Form.Group>

  <Form.Group as={Row} className="align-items-center mb-2">
    <Form.Label column sm={4}>
      {t("basicSettings.otherDetails.expirationDays")}
    </Form.Label>
    <Col sm={8}>
      <Form.Control
        type="number"
        value={pointsEarningCreteria?.lifecycle?.expirationDays || ""}
        onChange={(e) =>
          handleRewardSettingChange(
            "expirationDays",
            e.target.value
          )
        }
      />
    </Col>
  </Form.Group>

  {/* Usage Limit */}
  <Form.Group as={Row} className="align-items-center mb-3">
    <Form.Label column sm={4}>
      {t("basicSettings.otherDetails.maxUsagePercentage")}
    </Form.Label>
    <Col sm={8}>
      <Form.Control
        type="number"
        value={
          pointsEarningCreteria?.usageLimit?.maxUsagePercentage || ""
        }
        onChange={(e) =>
          handleRewardSettingChange(
            "maxUsagePercentage",
            e.target.value
          )
        }
      />
    </Col>
  </Form.Group>

  {/* Currency Ratios */}
  {pointsEarningCreteria?.value?.map((item, index) => (
    <Row key={item._id} className="mb-2">
      <Col sm={4}>
        <Form.Label>
          1 Point value in {item.currency}
          
        </Form.Label>
      </Col>
      <Col sm={8}>
        <Form.Control
          type="number"
          value={item.pointToCurrencyRatio}
          onChange={(e) =>
            handleRewardRatioChange(index, e.target.value)
          }
        />
      </Col>
      
    </Row>
  ))}
</div>




        <div className="text-end mt-4">
          <Button variant="primary" onClick={handleSave} disabled={loading}>
            {loading ? t("basicSettings.saving") : t("basicSettings.saveChanges")}
          </Button>
        </div>
      </div>
    </>
  );
};

export default BasicSettings;
